@if (duplicatesHint(); as hint) {
  <p class="ou-duplicates" role="note" data-testid="ou-duplicates">{{ hint.key | translate: hint.params }}</p>
}

@if (rename(); as names) {
  <div class="ou-box" data-testid="ou-preview">
    <div class="ou-preview__head" data-testid="ou-preview-head">
      {{ previewHead().key | translate: { count: previewHead().count } }}
    </div>
    @for (place of places(); track $index) {
      <div class="ou-preview__row" data-testid="ou-preview-row">
        <code class="ou-preview__key">{{ place.key }}</code>
        <del class="ou-preview__old">
          <span class="sr-only">{{ 'objectMappings.usages.oldText' | translate }}</span>
          {{ names.oldName }}
        </del>
        <span class="ou-preview__arrow" aria-hidden="true">→</span>
        <ins class="ou-preview__new">
          <span class="sr-only">{{ 'objectMappings.usages.newText' | translate }}</span>
          {{ names.newName }}
        </ins>
        @if (place.stepKey) {
          <span class="ou-preview__step">{{ place.stepKey }}</span>
        }
      </div>
    }
  </div>
} @else if (places().length === 0) {
  <p class="ou-empty" data-testid="ou-empty">{{ 'objectMappings.usages.empty' | translate }}</p>
} @else {
  <div class="ou-box">
    @for (place of places(); track $index) {
      <a class="ou-place" data-testid="ou-place" [routerLink]="place.link" (click)="opened.emit()">
        @if (place.icon; as icon) {
          <app-icon class="ou-place__icon" [name]="icon" [size]="14" />
        } @else {
          <mat-icon class="ou-place__icon ou-place__icon--step" aria-hidden="true">list</mat-icon>
        }
        <code class="ou-place__key">{{ place.key }}</code>
        <span class="ou-place__title">{{ place.title }}</span>
        @if (place.line; as line) {
          <code class="ou-place__line">
            @if (line.lineNumber === null) {
              {{ 'objectMappings.usages.stepCondition' | translate }}
            } @else {
              {{ line.text ?? line.reference }}
            }
          </code>
        }
      </a>
    }
  </div>
}
